import type { NavigationService } from '@omnia/ui/src/lib/services/navigation.service'
import { UrlService } from '@omnia/ui/src/lib/services/url.service'
import type { MemberSubPages, PagesEnum } from './models/pages'

export class CineColombiaUrlService extends UrlService<PagesEnum, MemberSubPages> {
    protected filmDetailsPage: keyof PagesEnum = 'FilmDetails'
    protected cinemaPage: keyof PagesEnum
    protected navigationService: NavigationService<PagesEnum, MemberSubPages>
    // Add custom methods here

    public constructor(_navigationService: NavigationService<PagesEnum, MemberSubPages>) {
        super()
        this.navigationService = _navigationService
    }
}
